import React from 'react';
import styless from '../schedulePOComps/orderdetails.module.css';

const STEPS = ['Order received', 'Processing', 'on the way', 'Delivered'];

// Which step (0-3) each order status has reached, per order type
const STEP_BY_STATUS = {
    // Cart / PO orders
    order: { PROCESSING: 1, SHIPPED: 2, DELIVERED: 3 },
    // Vendor received orders
    received: { PROCESSING: 1, PENDING: 1, SHIPPED: 2, DELIVERED: 3 },
    // Schedule orders
    schedule: { APPROVED: 1, AWAITING: 1, PENDING: 1, RESCHEDULE: 1, DISPATCHED: 2, DELIVERED: 3, COMPLETED: 3 },
};

const CANCELLED = ['CANCELLED', 'CANCELED'];

// Order tracker: Order received -> Processing -> on the way -> Delivered
const OrderProgress = ({ status, type = 'order' }) => {
    const current = String(status || '').toUpperCase();

    if (CANCELLED.includes(current)) {
        return (
            <div style={{ margin: '32px 0', padding: '14px 18px', borderRadius: 10, background: '#FEF3F2', color: '#B42318', fontWeight: 600, fontSize: 14, textAlign: 'center' }}>
                This order was cancelled
            </div>
        );
    }

    const reached = STEP_BY_STATUS[type]?.[current] ?? 0;

    return (
        <div className={styless.progress_container}>
            {STEPS.map((label, index) => {
                const active = index <= reached;
                return (
                    <div key={label} className={`${styless.progress_step} ${active ? styless.active : ''}`}>
                        <div className={styless.circle}>{index === 0 ? '✔' : String(index + 1).padStart(2, '0')}</div>
                        <div className={styless.progressmobile} style={{ color: active ? '#2C742F' : '#333333' }}>
                            <p>{label}</p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default OrderProgress;
